import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicGuideProcessBar from '../../RifoDesign/EpicGuideProcessBar/epic.guide.process.bar.vue';
import EpicStepDetail from '../../RifoDesign/EpicStepDetail/epic.step.detail.vue';
import { SubStep } from '../../RifoDesign/EpicStepDetail/epic.step.detail.component';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';

export interface Step {
    bgColor: string;
    graphic: string;
    reverse: boolean;
    stepName: string;
    detail: SubStep[];
}

@Component({
    components: {
        EpicHeaderBannerText,
        EpicGuideProcessBar,
        EpicStepDetail,
        'layout': EpicStandardLayout
    }
})
export default class EpicSellerGuidePage extends Vue {
    public configs = new CommonConfig();
    public stepsAll: Step[] = [];
    public points: ClientRect[] = [];
    public containerTop: number = 0;
    public leftBarHeight: number = 0;
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg2.jpg`;
    public created() {
        this.stepsAll = [{
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step1-img.png`,
            reverse: false,
            bgColor: '#ECF8FA',
            stepName: 'Prepare for Selling',
            detail: [{
                name: 'Step 1: Know Housing Market',
                preText: 'Understand weather the market is seller’s market or buyer’s market, and decide to sell the house in a right season.',
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon1-1.png`,
                    title: 'Seller’s Market',
                    paragraph: 'Lots of people are looking for houses while few houses are for sale.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon1-2.png`,
                    title: 'Buyer’s Market',
                    paragraph: 'Lots of homes for sale but not many people are buying them.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon1-3.png`,
                    title: 'Warm Season',
                    paragraph: 'Warm seasons like spring and summer have better house selling activities than cold seasons'
                }],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 2: Know The Finance',
                preText: 'Before you sell your property, there are some finance knowledge you should understand',
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon2-1.png`,
                    title: 'Discharge Mortgage ',
                    paragraph: 'When you plan to sell a house but don’t want to buy an new one, your mortgage turns to discharge mortgage, you need to pay penalty to lender'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon2-2.png`,
                    title: 'Portable Mortgage',
                    paragraph: 'When you sell your old house to buy a new one, you can simply ask your lender to change the mortgage plan without penalty '
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon2-3.png`,
                    title: 'Capital Gains Tax',
                    paragraph: `If you rent your property to tenants, or you are selling your vacation or investment house,
                     you owe capital gain tax that generated from your property profits.`
                }],
                afterText: 'RIFO provide professional finance services to solve any finance problems relative to your selling activity.',
                btnText: '',
                btnHref: ''
            }, {
                name: 'Step 3: Meet An RIFO  Real Estate Agent',
                preText: `RIFO have thousands of experienced real estate agents to help you maximize your property value,
                 please do not hesitate to schedule an real estate agent from us`,
                detailList: [],
                afterText: '',
                btnText: 'Contact Us',
                btnHref: '/contact-us'
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/graphic2.png`,
            reverse: true,
            bgColor: '#fff',
            stepName: 'Listing Your House',
            detail: [{
                name: 'Step 4: Analyze The Market',
                preText: `Our RIFO real estate agents will do their best to serve you by analyzing the current marketing trends,
                 recommending the best time to sell or buy a property.   make sure you save as much money as possible.`,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 5: Set Asking Price Smartly',
                preText: `Selling a house by a high price is definitely good, but an excessive asking price will scale away most of potential buyers,
                 RIFO agents offer asking price plans smartly for you to generate highest profits for your.`,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: ''
            }, {
                name: 'Step 6: Sign a Listing Agreement',
                preText: `Signing a listing agreement with a RIFO agent to authorize the agent to proceed your selling activity.
                 most listing agreement includes: `,
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step2-1.png`,
                    title: 'Authority',
                    paragraph: 'The agreement indicates a legal relationship between seller and real estate brokerage to have a limited term to sell your house.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step2-2.png`,
                    title: 'Commission Fee',
                    paragraph: 'Seller agrees to give a proportion of final house selling price as commission fee to listing agent.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step2-3.png`,
                    title: 'Asking Price',
                    paragraph: 'Seller and RIFO agent agree with a asking price to sell the house, if seller want to change asking price, seller should resign an new agreement.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step2-4.png`,
                    title: 'Legal information',
                    paragraph: 'Listing agreement will indicate all possible legal information to legalize both sides‘ behaviors.'
                }],
                afterText: '',
                btnText: '',
                btnHref: ''
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/graphic3.png`,
            reverse: false,
            bgColor: '#ECF8FA',
            stepName: 'Marketing Your house',
            detail: [{
                name: 'Step 7: Multimedia Advertisement',
                preText: `A professional RIFO agent knows how to utilize multimedia to advertise your house properly`,
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step3-1.png`,
                    title: 'Traditional Media',
                    paragraph: 'Your RIFO agent may use printed media such us newspaper and flyers to publish your house ads.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/icon2-2.png`,
                    title: 'Digital Media',
                    paragraph: 'RIFO have launched powerful RIFO app for seller to post your house on a real estate board’s MLS® System.'
                }],
                afterText: '',
                btnText: 'Download App',
                btnHref: '/download-app',
            }, {
                name: 'Step 8: Agent Sign',
                preText: 'Agent Signs are always the most effecient way to attract potential buyers  ',
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step3-4.png`,
                    title: 'For Sale Sign',
                    paragraph: 'RIFO agent provides well designed  for sale sign to make your house stand out from other houses.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step3-4.png`,
                    title: 'Open House Sign',
                    paragraph: 'RIFO agent also offer appearing open house sign to attract more potential buyers nearby your property.'
                }],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 9: Open House',
                preText: `RIFO agent will show your house to other real estate agents and any buyers who have interests to your house.
                 RIFO agent may stage your house to highlight your home’s strengths, downplay its weaknesses, and make visitors get a free feel in your house.`,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/graphic4.png`,
            reverse: true,
            bgColor: '#fff',
            stepName: 'Make the deal',
            detail: [{
                name: 'Step 10: Find A Trusted Lawyer',
                preText: `Finding a trusted lawyer in RIFO team to handle all necessary legal documents related to the selling process.
                 It is essential to let the lawyer review important terms in the offer before you sign your signature. `,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 11:  Responding to Offers',
                preText: `Once your list your house in the market, you may receive many offers from different buyers that give different prices and conditions.
                 A RIFO agent will walk you through the entire selling process by giving advices before you make your final decision. You can: `,
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step4-1.png`,
                    title: 'Accept An Ideal Offer',
                    paragraph: 'An offer provides an ideal price you were expecting,  or even give a higher price, you can definitely think of accepting it.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-seller-guide/step4-2.png`,
                    title: '"Sign Back" An Offer',
                    paragraph: `If an offer gives a price that doesn’t match your asking price,
                     or some undesirable conditions are listed on the offer, your RIFO agent will negotiate with the buyer for a better price and conditions.`
                }],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 12: Closing The Sale',
                preText: `Once You accept an offer, Congrats, Your sale is reaching the final step.
                 RIFO agent will ask you as seller to provide identification such as driver’s license or passport based on federal law.<br/><br/>
                 Please contact your lawyer frequently to check all the documents to avoid any legal faults.
                 Contact all institutions and companies to transfer or remove the services for your sold house, usually your lawyer will handle the transfer process.<br/><br/>
                 Your lawyer will show all you all outstanding balance on your mortgage, and any penalties you have to pay. Before the closing day,
                 your lawyer will ask you to sign a paperwork to transfer your house ownership to the buyer.<br/><br/>
                 Once you finish all processes above, you need to move out from the house on the closing day,
                 RIFO also supply moving services to carefully move your belongings. You are welcome to contact RIFO at any time.  `,
                detailList: [],
                afterText: '',
                btnText: 'Contact Us',
                btnHref: '/contact-us',
            }]
        }];

    }
    public mounted() {
        const containerEl = (this.$refs[`container`] as any);
        this.containerTop = containerEl.getBoundingClientRect().top;
        for (let i = 0; i < this.stepsAll.length; i++) {
            const el = (this.$refs[`step_${i}`] as any)[0].$el;
            this.points.push(el.getBoundingClientRect());
        }
        this.leftBarHeight =  this.points[this.stepsAll.length - 1].top - this.points[0].top;
    }
}
